export default "images/实时路线导航.png";